import React, { useState, useEffect } from "react";
import InputComponent from "../Input/input";
import Swal from "sweetalert2";
import localPagamentoService from "../../services/LocalPagamentoService";
import SelectComponent from "../Select/select";
import { Label } from "../Label/styles";
import BancoService from "../../services/BancoService";
import { Badge, Col, Form, Row } from "react-bootstrap";
import {
  BlueTitle,
  ButtonGroupEnd,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  StyledHR,
  TextError,
} from "../../shared/styles/global.styles";
import Button from "../Button/button";
import { IoCloseSharp } from "react-icons/io5";
import { LayoutRemessaRetornoDto } from "../../shared/dtos/LayoutRemessaRetorno.dto";
import layoutRemessaRetornoService from "../../services/LayoutRemessaRetornoService";
import { TypeLayoutRemessaRetornoEnum } from "../../shared/enum/layoutRemessaRetorno.enum";
import { GetBancoDto } from "../../shared/dtos/Banco.dto";

const PagamentoFormModal = ({
  show,
  onClose,
  onSavePagamento,
  pagamentoParaEditar,
}: {
  show: boolean;
  onClose: () => void;
  onSavePagamento: (pagamento: any) => void;
  pagamentoParaEditar?: any;
}) => {
  const [pagamento, setPagamento] = useState({
    id: undefined,
    descricao: "",
    cnpj: "",
    convenio: "",
    carteira: "",
    banco: "",
    posto: "",
    cooperativa: "",
    codBeneficiario: "",
    agencia: "",
    contaCorrente: "",
    diaVencimento: 1,
    byteGeracao: "",
    nossoNumero: "",
    tipocodigoBarras: "",
    idLayoutRemessa: "",
    idLayoutRetorno: "",
    chavePix: "",
    imprimirDocs: true,
    gerarRemessa: true,
    instrucaoBoleto1: "",
    instrucaoBoleto2: "",
    instrucaoBoleto3: "",
    instrucaoBoleto4: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [bancos, setBancos] = useState<GetBancoDto[]>([]);
  const [layoutRemessaRetorno, setLayoutRemessaRetorno] = useState<
    LayoutRemessaRetornoDto[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [selectedTypeLayoutRemessa, setSelectedTypeLayoutRemessa] =
    useState<TypeLayoutRemessaRetornoEnum>();

  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  const [nextLine, setNextLine] = useState<boolean>(false);
  const [lineCount, setLineCount] = useState<number>(1);

  const fetchBancos = async () => {
    try {
      setLoading(true);
      const bancosData = await BancoService.getBancos();

      setBancos(bancosData);
    } catch (error) {
      console.error("Erro ao carregar bancos:", error);
      Swal.fire("Erro", "Não foi possível carregar a lista de bancos", "error");
    } finally {
      setLoading(false);
    }
  };
  const fetchLayoutRemessaRetorno = async () => {
    try {
      setLoading(true);
      const layoutRemessaRetornoData =
        await layoutRemessaRetornoService.getAllLayoutRemessaRetorno();

      setLayoutRemessaRetorno(layoutRemessaRetornoData);
    } catch (error) {
      console.error("Erro ao carregar os layouts:", error);
      Swal.fire(
        "Erro",
        "Não foi possível carregar a lista de layouts",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLayoutRemessaRetorno();
    fetchBancos();
  }, []);

  useEffect(() => {
    if (pagamentoParaEditar) {
      setPagamento(pagamentoParaEditar);
      const selectedLayout = layoutRemessaRetorno.find(
        (layout) => layout.id === Number(pagamentoParaEditar.idLayoutRemessa)
      );
      setSelectedTypeLayoutRemessa(selectedLayout?.type);
    } else {
      setPagamento({
        id: undefined,
        descricao: "",
        cnpj: "",
        convenio: "",
        carteira: "",
        banco: "",
        posto: "",
        cooperativa: "",
        codBeneficiario: "",
        agencia: "",
        contaCorrente: "",
        diaVencimento: 1,
        byteGeracao: "",
        nossoNumero: "",
        tipocodigoBarras: "",
        idLayoutRemessa: "",
        idLayoutRetorno: "",
        chavePix: "",
        imprimirDocs: true,
        gerarRemessa: true,
        instrucaoBoleto1: "",
        instrucaoBoleto2: "",
        instrucaoBoleto3: "",
        instrucaoBoleto4: "",
      });
    }
  }, [pagamentoParaEditar]);

  const handleCancel = () => {
    setPagamento({
      id: undefined,
      descricao: "",
      cnpj: "",
      convenio: "",
      carteira: "",
      banco: "",
      posto: "",
      cooperativa: "",
      codBeneficiario: "",
      agencia: "",
      contaCorrente: "",
      diaVencimento: 1,
      byteGeracao: "",
      nossoNumero: "",
      tipocodigoBarras: "",
      idLayoutRemessa: "",
      idLayoutRetorno: "",
      chavePix: "",
      imprimirDocs: true,
      gerarRemessa: true,
      instrucaoBoleto1: "",
      instrucaoBoleto2: "",
      instrucaoBoleto3: "",
      instrucaoBoleto4: "",
    });
    onClose();
  };

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = event.target;

    let formattedValue = value;

    if (name === "cnpj") {
      formattedValue = value.replace(/\D/g, ""); // Remove caracteres não numéricos
      if (formattedValue.length === 14) {
        // Formata o CNPJ se tiver 14 dígitos
        formattedValue = formattedValue.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      }
    }

    setPagamento((prev) => ({
      ...prev,
      [name]: formattedValue, // Atualiza o estado com o valor formatado
    }));
    clearError(event);
  };

  const validateForm = (): boolean => {
    if (!pagamento.descricao.trim()) {
      Swal.fire("Erro", "A descrição é obrigatória!", "warning");
      setInvalidFields((prev) => [...prev, "descricao"]);
      return false;
    }
    if (!pagamento.cnpj || !isValidCNPJ(pagamento.cnpj)) {
      Swal.fire("Erro", "CNPJ inválido!", "warning");
      setInvalidFields((prev) => [...prev, "cnpj"]);
      return false;
    }
    if (!pagamento.banco) {
      Swal.fire("Erro", "O banco é obrigatório!", "warning");
      setInvalidFields((prev) => [...prev, "banco"]);
      return false;
    }
    if (!pagamento.convenio) {
      Swal.fire("Erro", "O convênio é obrigatório!", "warning");
      setInvalidFields((prev) => [...prev, "convenio"]);
      return false;
    }
    if (!pagamento.carteira) {
      Swal.fire("Erro", "A carteira é obrigatória!", "warning");
      setInvalidFields((prev) => [...prev, "carteira"]);
      return false;
    }

    if (!pagamento.agencia) {
      Swal.fire("Erro", "A agência é obrigatória!", "warning");
      setInvalidFields((prev) => [...prev, "agencia"]);
      return false;
    }
    if (!pagamento.contaCorrente) {
      Swal.fire("Erro", "A conta corrente é obrigatória!", "warning");
      setInvalidFields((prev) => [...prev, "contaCorrente"]);
      return false;
    }
    if (!pagamento.idLayoutRemessa) {
      Swal.fire("Erro", "A layout de remessa é obrigatório!", "warning");
      setInvalidFields((prev) => [...prev, "idLayoutRemessa"]);
      return false;
    }
    if (!pagamento.idLayoutRetorno) {
      Swal.fire("Erro", "A layout de retorno é obrigatório!", "warning");
      setInvalidFields((prev) => [...prev, "idLayoutRetorno"]);
      return false;
    }
    if (!pagamento.instrucaoBoleto1) {
      Swal.fire("Erro", "A instrução bancária é obrigatória!", "warning");
      setInvalidFields((prev) => [...prev, "conteudo"]);
      return false;
    }
    return true;
  };

  const isValidCNPJ = (cnpj: string): boolean => {
    const sanitized = cnpj.replace(/\D/g, ""); // Remove todos os caracteres não numéricos

    if (sanitized.length !== 14) {
      return false;
    }

    let size = sanitized.length - 2;
    let numbers = sanitized.substring(0, size);
    const digits = sanitized.substring(size);
    let sum = 0;
    let pos = size - 7;

    // Primeiro dígito verificador
    for (let i = size; i >= 1; i--) {
      const multiplier = pos--;
      sum += +numbers[size - i] * multiplier;
      if (pos < 2) pos = 9;
    }

    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== +digits[0]) {
      return false;
    }

    // Segundo dígito verificador
    size += 1;
    numbers = sanitized.substring(0, size);
    sum = 0;
    pos = size - 7;

    for (let i = size; i >= 1; i--) {
      const multiplier = pos--;
      sum += +numbers[size - i] * multiplier;
      if (pos < 2) pos = 9;
    }

    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== +digits[1]) {
      return false;
    }

    return true; // CNPJ válido
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      const pagamentoData = {
        ...pagamento,
        banco: Number(pagamento.banco),
        posto: Number(pagamento.posto),
        cooperativa: Number(pagamento.cooperativa),
        agencia: Number(pagamento.agencia),
        codBeneficiario: Number(pagamento.codBeneficiario), // Certifique-se de que `codBeneficiario` é o campo correto
        contaCorrente: Number(pagamento.contaCorrente.replace(/\D/g, "")),
        byteGeracao: Number(pagamento.byteGeracao),
        nossoNumero: Number(pagamento.nossoNumero),
        tipoCodigoBarras: Number(pagamento.tipocodigoBarras), // Certifique-se de que `tipocodigoBarras` é o campo correto
        idLayoutRemessa: Number(pagamento.idLayoutRemessa),
        idLayoutRetorno: Number(pagamento.idLayoutRetorno),
        carteira: String(pagamento.carteira), // Se necessário como string
        cnpj: removeSpecialCharacters(pagamento.cnpj), // Remove "." e "-" do CNPJ
        diaVencimento: pagamento.diaVencimento,
        instrucaoBoleto1: pagamento.instrucaoBoleto1,
        instrucaoBoleto2: pagamento.instrucaoBoleto2,
        instrucaoBoleto3: pagamento.instrucaoBoleto3,
        instrucaoBoleto4: pagamento.instrucaoBoleto4,
      };

      const response = await localPagamentoService.createLocalPagamento(
        pagamentoData
      );

      Swal.fire("Sucesso!", "Pagamento salvo com sucesso!", "success");
      onSavePagamento(response);
      handleCancel(); // Fecha o modal após salvar
    } catch (error) {
      console.error("[handleSubmit] Erro ao salvar o pagamento:", error);
      Swal.fire(
        "Erro",
        "Erro ao salvar o pagamento. Por favor, tente novamente.",
        "error"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const clearError = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name } = event.target;

    setInvalidFields((prev) => prev.filter((field) => field !== name));
  };

  if (!show) return null;

  const removeSpecialCharacters = (value: string) => value.replace(/\D/g, "");

  return (
    <ModalContainer show={show}>
      <ModalContent>
        <Button
          type="button"
          schemaButton="x-close"
          action={handleCancel}
          icon={<IoCloseSharp size={30} />}
          position="absolute"
          top={10}
          right={10}
        />
        <ModalHeader>
          <BlueTitle>
            {pagamento.id
              ? "Editar Local de Pagamento"
              : "Cadastrar novo local de pagamento"}
          </BlueTitle>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <Label htmlFor="descricao">
                Descrição <TextError>*</TextError>
              </Label>
              <InputComponent
                type="text"
                id="descricao"
                name="descricao"
                value={pagamento.descricao}
                onChange={handleInputChange}
                placeholder="Insira a descrição"
                color="#333"
                width={Number("100%")}
                border="1px solid #ccc"
                errorMessage={
                  invalidFields.includes("descricao")
                    ? "A descrição é obrigatória"
                    : ""
                }
              />
            </Col>
            <Col>
              <Label htmlFor="cnpj">
                CNPJ <TextError>*</TextError>
              </Label>
              <InputComponent
                type="text"
                id="cnpj"
                name="cnpj"
                value={pagamento.cnpj}
                onChange={handleInputChange}
                placeholder="Insira o CNPJ"
                color="#333"
                width={Number("100%")}
                border="1px solid #ccc"
                errorMessage={
                  invalidFields.includes("cnpj") ? "O CNPJ é obrigatório" : ""
                }
              />
            </Col>
            <Col>
              <Label htmlFor="convenio">
                Convênio <TextError>*</TextError>
              </Label>
              <InputComponent
                type="text"
                id="convenio"
                name="convenio"
                value={pagamento.convenio}
                onChange={(event) => {
                  const value = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                  if (value.length <= 2) {
                    // Only allow 2 digits
                    setPagamento((prev) => ({
                      ...prev,
                      convenio: value,
                    }));
                  }
                }}
                placeholder="Insira o convênio"
                color="#333"
                width={Number("100%")}
                border="1px solid #ccc"
              />
            </Col>
            <Col>
              <Label htmlFor="carteira">
                Carteira <TextError>*</TextError>
              </Label>
              <InputComponent
                type="text"
                id="carteira"
                name="carteira"
                value={pagamento.carteira}
                onChange={(event) => {
                  const value = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                  if (value.length <= 3) {
                    setPagamento((prev) => ({
                      ...prev,
                      carteira: value,
                    }));
                  }
                }}
                placeholder="Insira a carteira"
                color="#333"
                width={Number("100%")}
                border="1px solid #ccc"
                errorMessage={
                  invalidFields.includes("carteira")
                    ? "A carteira é obrigatória"
                    : ""
                }
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Label htmlFor="banco">
                Banco <TextError>*</TextError>
              </Label>
              <SelectComponent
                color="black"
                placeholder="Selecione um Banco"
                id="banco"
                width={Number("100%")}
                name="banco"
                value={pagamento.banco}
                onChange={handleInputChange}
                options={bancos.map((banco) => ({
                  value: banco.codigo.toString(),
                  label: `${banco.codigo} - ${banco.nome}`,
                }))}
                disabled={loading}
                errorMessage={
                  invalidFields.includes("banco") ? "O banco é obrigatório" : ""
                }
              />
            </Col>
            <Col>
              <Label htmlFor="agencia">
                Agência <TextError>*</TextError>
              </Label>
              <InputComponent
                type="text"
                id="agencia"
                name="agencia"
                value={pagamento.agencia}
                onChange={(event) => {
                  const value = event.target.value; // Remove non-numeric characters
                  if (value.length <= 5) {
                    setPagamento((prev) => ({
                      ...prev,
                      agencia: value,
                    }));
                  }
                }}
                placeholder="Insira a Agência"
                color="#333"
                width={Number("100%")}
                border="1px solid #ccc"
              />
            </Col>
            <Col>
              <Label htmlFor="contaCorrente">
                Conta corrente <TextError>*</TextError>
              </Label>
              <InputComponent
                type="text"
                id="contaCorrente"
                name="contaCorrente"
                value={pagamento.contaCorrente}
                onChange={(event) => {
                  const value = event.target.value;
                  if (value.length <= 12) {
                    // Format value with hyphen before last digit based on length
                    const formattedValue = value.replace(/\D/g, ""); // Remove non-numeric chars
                    const len = formattedValue.length;
                    if (len >= 2 && len <= 11) {
                      const prefix = formattedValue.slice(0, -1);
                      const lastDigit = formattedValue.slice(-1);
                      setPagamento((prev) => ({
                        ...prev,
                        contaCorrente: `${prefix}-${lastDigit}`,
                      }));
                    } else {
                      setPagamento((prev) => ({
                        ...prev,
                        contaCorrente: formattedValue,
                      }));
                    }
                  }
                }}
                placeholder="Insira a Conta Corrente"
                color="#333"
                width={Number("100%")}
                border="1px solid #ccc"
                errorMessage={
                  invalidFields.includes("contaCorrente")
                    ? "A conta corrente é obrigatória"
                    : ""
                }
              />
            </Col>
            <Col>
              <Label htmlFor="agencia">
                Posto <TextError>*</TextError>
              </Label>
              <InputComponent
                type="text"
                id="agencia"
                name="agencia"
                value={pagamento.posto}
                onChange={(event) => {
                  const value = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                  if (value.length <= 2) {
                    // Only allow 2 digits
                    setPagamento((prev) => ({
                      ...prev,
                      posto: value,
                    }));
                  }
                }}
                placeholder="Insira o N° do posto"
                color="#333"
                width={Number("100%")}
                border="1px solid #ccc"
                maxLength={2} // Enforce 2 character limit
                errorMessage={
                  invalidFields.includes("posto") ? "O posto é obrigatório" : ""
                }
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Label htmlFor="tipocodigoBarras">
                Cooperativa <TextError>*</TextError>
              </Label>
              <InputComponent
                type="text"
                id="tipocodigoBarras"
                name="tipocodigoBarras"
                value={pagamento.cooperativa}
                onChange={(event) => {
                  const value = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                  if (value.length <= 4) {
                    setPagamento((prev) => ({
                      ...prev,
                      cooperativa: value,
                    }));
                  }
                }}
                placeholder="Insira o N° da cooperativa"
                color="#333"
                width={Number("100%")}
                border="1px solid #ccc"
                errorMessage={
                  invalidFields.includes("cooperativa")
                    ? "A cooperativa é obrigatória"
                    : ""
                }
              />
            </Col>
            <Col>
              <Label htmlFor="byteGeracao">
                Byte Geração <TextError>*</TextError>
              </Label>
              <InputComponent
                type="text"
                id="byteGeracao"
                name="byteGeracao"
                value={pagamento.byteGeracao}
                // disabled={!!pagamentoParaEditar}
                onChange={(event) => {
                  const value = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                  if (value.length <= 1) {
                    setPagamento((prev) => ({
                      ...prev,
                      byteGeracao: value,
                    }));
                  }
                }}
                min="1"
                max="9"
                placeholder="Insira o byte de geração"
                color="#333"
                width={Number("100%")}
                border="1px solid #ccc"
                errorMessage={
                  invalidFields.includes("byteGeracao")
                    ? "O byte de geração é obrigatório"
                    : ""
                }
              />
            </Col>
            <Col>
              <Label htmlFor="nossoNumero">
                Nosso Numero <TextError>*</TextError>
              </Label>
              <InputComponent
                type="text"
                id="nossoNumero"
                name="nossoNumero"
                value={pagamento.nossoNumero}
                onChange={(event) => {
                  const value = event.target.value;
                  if (value.length <= 5) {
                    setPagamento((prev) => ({
                      ...prev,
                      nossoNumero: value,
                    }));
                  }
                }}
                // disabled={!!pagamentoParaEditar}
                placeholder="Insira o banco"
                color="#333"
                width={Number("100%")}
                border="1px solid #ccc"
                errorMessage={
                  invalidFields.includes("nossoNumero")
                    ? "O nosso número é obrigatório"
                    : ""
                }
              />
            </Col>
            {/* <Col>
              <Label htmlFor="tipocodigoBarras">Código de barras</Label>
              <InputComponent
                type="text"
                id="tipocodigoBarras"
                name="tipocodigoBarras"
                value={pagamento.tipocodigoBarras}
                onChange={handleInputChange}
                placeholder="Insira o código de barras"
                color="#333"
                width={Number("100%")}
                border="1px solid #ccc"
              />
            </Col> */}
            <Col>
              <Label htmlFor="tipocodigoBarras">
                Código de beneficiário <TextError>*</TextError>
              </Label>
              <InputComponent
                type="text"
                id="tipocodigoBarras"
                name="tipocodigoBarras"
                value={pagamento.codBeneficiario}
                onChange={(event) => {
                  const value = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                  if (value.length <= 5) {
                    setPagamento((prev) => ({
                      ...prev,
                      codBeneficiario: value,
                    }));
                  }
                }}
                placeholder="Insira o N° do código de beneficiário"
                color="#333"
                width={Number("100%")}
                border="1px solid #ccc"
                errorMessage={
                  invalidFields.includes("codBeneficiario")
                    ? "O código de beneficiário é obrigatório"
                    : ""
                }
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Label htmlFor="diaVencimento">
                Dia do vencimento <TextError>*</TextError>
              </Label>
              <InputComponent
                type="text"
                id="diaVencimento"
                name="diaVencimento"
                value={pagamento.diaVencimento.toString()}
                onChange={handleInputChange}
                placeholder="1 a 30"
                color="#333"
                width={Number("100%")}
                border="1px solid #ccc"
                maxLength={2}
                errorMessage={
                  invalidFields.includes("diaVencimento")
                    ? "O dia do vencimento é obrigatório"
                    : ""
                }
              />
            </Col>
            <Col>
              <Label htmlFor="banco">
                Layout de Remessa <TextError>*</TextError>
              </Label>
              <SelectComponent
                color="black"
                placeholder="Selecione um tipo de layout de remessa"
                id="layoutRemessa"
                width={Number("100%")}
                name="layoutRemessa"
                value={String(pagamento.idLayoutRemessa)}
                onChange={(event) => {
                  setPagamento((prev) => ({
                    ...prev,
                    idLayoutRemessa: event.target.value,
                  }));
                  const selectedLayout = layoutRemessaRetorno.find(
                    (layout) => layout.id === Number(event.target.value)
                  );
                  setSelectedTypeLayoutRemessa(selectedLayout?.type);
                }}
                options={layoutRemessaRetorno.map((layout) => ({
                  value: `${layout.id}`,
                  label: `${layout.nome} - ${layout.type}`,
                }))}
                disabled={loading}
                errorMessage={
                  invalidFields.includes("layoutRemessa")
                    ? "O layout de remessa é obrigatório"
                    : ""
                }
              />
            </Col>
            <Col>
              <Label htmlFor="banco">
                Layout de Retorno <TextError>*</TextError>
              </Label>
              <SelectComponent
                color="black"
                placeholder="Selecione um tipo de layout de Retorno"
                id="layoutRetorno"
                width={Number("100%")}
                name="layoutRetorno"
                value={String(pagamento.idLayoutRetorno)}
                onChange={(event) => {
                  setPagamento((prev) => ({
                    ...prev,
                    idLayoutRetorno: event.target.value,
                  }));
                }}
                options={layoutRemessaRetorno.map((layout) => ({
                  value: `${layout.id}`,
                  label: `${layout.nome} - ${layout.type}`,
                }))}
                disabled={loading}
                errorMessage={
                  invalidFields.includes("layoutRetorno")
                    ? "O layout de retorno é obrigatório"
                    : ""
                }
              />
            </Col>
            <Col>
              <Label htmlFor="chavePix">
                Chave Pix <TextError>*</TextError>
              </Label>
              <InputComponent
                type="text"
                id="chavePix"
                name="chavePix"
                value={pagamento.chavePix}
                onChange={handleInputChange}
                placeholder="Insira a chave pix"
                color="#333"
                width={Number("100%")}
                border="1px solid #ccc"
                errorMessage={
                  invalidFields.includes("chavePix")
                    ? "A chave pix é obrigatória"
                    : ""
                }
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Label htmlFor="imprimirDocs">
                Imprimir Docs <TextError>*</TextError>
              </Label>
              <SelectComponent
                color="black"
                placeholder="Selecione"
                id="imprimirDocs"
                width={Number("100%")}
                name="imprimirDocs"
                value={pagamento.imprimirDocs ? "true" : "false"}
                onChange={(e) =>
                  setPagamento((prev) => ({
                    ...prev,
                    imprimirDocs: e.target.value === "true", // Converte para booleano
                  }))
                }
                options={[
                  { value: "true", label: "Sim" },
                  { value: "false", label: "Não" },
                ]}
                errorMessage={
                  invalidFields.includes("imprimirDocs")
                    ? "O imprimir docs é obrigatório"
                    : ""
                }
              />
            </Col>
            <Col>
              <Label htmlFor="gerarRemessa">
                Gerar Remessa <TextError>*</TextError>
              </Label>
              <SelectComponent
                color="black"
                placeholder="Selecione"
                id="gerarRemessa"
                width={Number("100%")}
                name="gerarRemessa"
                value={pagamento.gerarRemessa ? "true" : "false"}
                onChange={(e) =>
                  setPagamento((prev) => ({
                    ...prev,
                    gerarRemessa: e.target.value === "true", // Converte para booleano
                  }))
                }
                options={[
                  { value: "true", label: "Sim" },
                  { value: "false", label: "Não" },
                ]}
                errorMessage={
                  invalidFields.includes("gerarRemessa")
                    ? "O gerar remessa é obrigatório"
                    : ""
                }
              />
            </Col>
          </Row>

          <Label htmlFor="conteudo">
            Instrução bancária <TextError>*</TextError>
          </Label>
          <div>
            <Form.Control
              as="textarea"
              style={{
                minHeight: "100px",
                maxHeight: "300px",
                overflow: "auto",
                resize: "none",
              }}
              placeholder="Conteúdo (máximo 7 linhas, cada linha com recomendação de 90 caracteres)"
              name="conteudo"
              id="conteudo"
              value={pagamento.instrucaoBoleto1 ?? ""}
              onChange={(e) => {
                const value = e.target.value;
                const lines = value.split("\n");
                if (lines.length > 7) {
                  e.target.value = value.substring(0, value.lastIndexOf("\n"));
                  return setLineCount(lines.length);
                }
                // const lastLine = lines[lines.length - 1];
                // if (lastLine.length > 90) {
                //   e.target.value = value.substring(0, value.length - 1);
                //   return setNextLine(true);
                // }
                // setNextLine(false);
                setLineCount(lines.length);
                setPagamento({
                  ...pagamento,
                  instrucaoBoleto1: value,
                });
                clearError({
                  target: { name: e.target.name, value },
                } as React.ChangeEvent<HTMLInputElement>);
              }}
              isInvalid={invalidFields.includes("conteudo")}
              rows={8}
              maxLength={800}
            />
            <div>
              <Row style={{ justifyContent: "start" }}>
                {pagamento.instrucaoBoleto1
                  ?.split("\n")
                  .slice(0, 4)
                  .map((line, index) => (
                    <Col key={index} xs="auto">
                      <Badge
                        bg={
                          pagamento.instrucaoBoleto1?.split("\n").length ===
                          index + 1
                            ? "primary"
                            : line.length > 90
                            ? "dark"
                            : "secondary"
                        }
                      >
                        Linha{" "}
                        {`${index + 1} de 7 - ${
                          line.length === 91 ? "90" : line.length
                        }/90 caracteres`}
                      </Badge>
                    </Col>
                  ))}
              </Row>
              <Row style={{ justifyContent: "start" }}>
                {pagamento.instrucaoBoleto1
                  ?.split("\n")
                  .slice(4, 7)
                  .map((line, index) => (
                    <Col key={index + 5} xs="auto">
                      <Badge
                        bg={
                          pagamento.instrucaoBoleto1?.split("\n").length ===
                          index + 5
                            ? "primary"
                            : line.length > 90
                            ? "dark"
                            : "secondary"
                        }
                      >
                        Linha{" "}
                        {`${index + 5} de 7 - ${line.length}/90 caracteres`}
                      </Badge>
                    </Col>
                  ))}
              </Row>
            </div>
          </div>
          {/* {nextLine && lineCount < 7 ? (
                <TextError>
                  Pule para próxima linha, limite de 90 caracteres por linha
                </TextError>
              ) : (
                nextLine &&
                lineCount >= 7 && (
                  <TextError>Limite para conteúdo atingido</TextError>
                )
              )} */}
          {lineCount >= 7 && <TextError>Limite de 7 linhas atingido</TextError>}
          {invalidFields.includes("conteudo") && (
            <TextError>O conteúdo é obrigatória</TextError>
          )}
        </ModalBody>
        <ModalFooter>
          <ButtonGroupEnd>
            <Button
              schemaButton="full-danger"
              action={() => {
                setPagamento({
                  id: undefined,
                  descricao: "",
                  cnpj: "",
                  convenio: "",
                  carteira: "",
                  banco: "",
                  posto: "",
                  cooperativa: "",
                  codBeneficiario: "",
                  agencia: "",
                  contaCorrente: "",
                  diaVencimento: 1,
                  byteGeracao: "",
                  nossoNumero: "",
                  tipocodigoBarras: "",
                  idLayoutRemessa: "",
                  idLayoutRetorno: "",
                  chavePix: "",
                  imprimirDocs: true,
                  gerarRemessa: true,
                  instrucaoBoleto1: "",
                  instrucaoBoleto2: "",
                  instrucaoBoleto3: "",
                  instrucaoBoleto4: "",
                });
                onClose();
              }}
            >
              Cancelar
            </Button>
            <Button
              type="button"
              schemaButton="full-primary"
              action={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting
                ? "Enviando..."
                : pagamento.id
                ? "Salvar Alterações"
                : "Cadastrar"}
            </Button>
          </ButtonGroupEnd>
        </ModalFooter>
      </ModalContent>
    </ModalContainer>
  );
};

export default PagamentoFormModal;
